// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file issues/v1/board_update.proto (package github.issues.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file issues/v1/board_update.proto.
 */
export const file_issues_v1_board_update: GenFile = /*@__PURE__*/
  fileDesc("Chxpc3N1ZXMvdjEvYm9hcmRfdXBkYXRlLnByb3RvEhBnaXRodWIuaXNzdWVzLnYxIncKEEJvYXJkRmllbGRDaGFuZ2USDQoFZmllbGQYASABKAkSKgoEZnJvbRgCIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIoCgJ0bxgDIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZSJXChBCb2FyZEFycmFuZ2VtZW50EhAKCGdyb3VwX2J5GAEgASgJEjEKC3N3aW1sYW5lX2J5GAIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlIpkBChJCb2FyZFVwZGF0ZVJlcXVlc3QSCgoCaWQYASABKAkSMwoHY2hhbmdlcxgCIAMoCzIiLmdpdGh1Yi5pc3N1ZXMudjEuQm9hcmRGaWVsZENoYW5nZRI3CgthcnJhbmdlbWVudBgDIAEoCzIiLmdpdGh1Yi5pc3N1ZXMudjEuQm9hcmRBcnJhbmdlbWVudBIJCgFxGAQgASgJIloKEEJvYXJkQnVja2V0VmFsdWUSCwoDa2V5GAEgASgJEgwKBG5hbWUYAiABKAkSKwoFY29sb3IYAyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUimgEKEEJvYXJkRmllbGRSZXN1bHQSDQoFZmllbGQYASABKAkSMQoFdmFsdWUYAiABKAsyIi5naXRodWIuaXNzdWVzLnYxLkJvYXJkQnVja2V0VmFsdWUSDAoEa2V5cxgDIAMoCRINCgVhZGRlZBgEIAMoCRIPCgdyZW1vdmVkGAUgAygJEhYKDnNvdXJjZV9tYXRjaGVkGAYgASgIIjAKCUJvYXJkQ2VsbBISCgpjb2x1bW5fa2V5GAEgASgJEg8KB3Jvd19rZXkYAiABKAki1gEKE0JvYXJkVXBkYXRlUmVzcG9uc2USCgoCaWQYASABKAkSMwoHcmVzdWx0cxgCIAMoCzIiLmdpdGh1Yi5pc3N1ZXMudjEuQm9hcmRGaWVsZFJlc3VsdBIqCgVjZWxscxgDIAMoCzIbLmdpdGh1Yi5pc3N1ZXMudjEuQm9hcmRDZWxsEiIKGmNoYW5nZWRfZmllbGRfbWF0Y2hlc192aWV3GAQgASgIEi4KCnVwZGF0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wYgZwcm90bzM", [file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * One field's change within a single gesture: the bucket key the card left, and the one
 * it entered.
 *
 * @generated from message github.issues.v1.BoardFieldChange
 */
export type BoardFieldChange = Message<"github.issues.v1.BoardFieldChange"> & {
  /**
   * The field's registry identifier, spelled as the board payload's `columnField` and
   * `rowField` spell it. Never a name slug: the slug is how the issue-field domain
   * addresses a row, and translating between the two is the server's job.
   *
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * The bucket key the card was in. Advisory for a single-valued field, authoritative for
   * a multi-valued one, which needs it to know which value to remove. Unset means the card
   * was in the no-value bucket.
   *
   * Never a precondition. Index lag is itself a cause of a stale source value, and
   * refusing on a mismatch would reject legitimate moves.
   *
   * @generated from field: google.protobuf.StringValue from = 2;
   */
  from?: string;

  /**
   * The bucket key the card was dropped in. Unset means the no-value bucket.
   *
   * @generated from field: google.protobuf.StringValue to = 3;
   */
  to?: string;
};

/**
 * Describes the message github.issues.v1.BoardFieldChange.
 * Use `create(BoardFieldChangeSchema)` to create a new message.
 */
export const BoardFieldChangeSchema: GenMessage<BoardFieldChange> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_update, 0);

/**
 * What the board is arranged by, which is not the same as what changed: a sideways drag
 * leaves one axis untouched and the response still has to name the whole cell.
 *
 * @generated from message github.issues.v1.BoardArrangement
 */
export type BoardArrangement = Message<"github.issues.v1.BoardArrangement"> & {
  /**
   * @generated from field: string group_by = 1;
   */
  groupBy: string;

  /**
   * @generated from field: google.protobuf.StringValue swimlane_by = 2;
   */
  swimlaneBy?: string;
};

/**
 * Describes the message github.issues.v1.BoardArrangement.
 * Use `create(BoardArrangementSchema)` to create a new message.
 */
export const BoardArrangementSchema: GenMessage<BoardArrangement> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_update, 1);

/**
 * @generated from message github.issues.v1.BoardUpdateRequest
 */
export type BoardUpdateRequest = Message<"github.issues.v1.BoardUpdateRequest"> & {
  /**
   * The card's global id. Echoed back verbatim in the response, never resolved-and-echoed:
   * a response carrying a different id folds the pending operation onto nothing and the
   * card snaps back with no error anywhere.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * One entry per field this gesture changed. A diagonal drag carries two, and one change
   * and two changes take the same path.
   *
   * @generated from field: repeated github.issues.v1.BoardFieldChange changes = 2;
   */
  changes: BoardFieldChange[];

  /**
   * @generated from field: github.issues.v1.BoardArrangement arrangement = 3;
   */
  arrangement?: BoardArrangement;

  /**
   * The effective search, verbatim, for computing `changed_field_matches_view`.
   *
   * @generated from field: string q = 4;
   */
  q: string;
};

/**
 * Describes the message github.issues.v1.BoardUpdateRequest.
 * Use `create(BoardUpdateRequestSchema)` to create a new message.
 */
export const BoardUpdateRequestSchema: GenMessage<BoardUpdateRequest> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_update, 2);

/**
 * A bucket's identity and how it draws: enough to render the card's chip in its new cell.
 * Everything else about the card comes from the next board read.
 *
 * @generated from message github.issues.v1.BoardBucketValue
 */
export type BoardBucketValue = Message<"github.issues.v1.BoardBucketValue"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * A string rather than an enum, matching what the read payload already sends
   * (`IssueSearchField::Field::IssueField::OptionColor#serialize`). The browser writes this
   * value straight into the card's existing field entry, and an enum here would put a
   * mapping step between the write response and the card it updates.
   *
   * @generated from field: google.protobuf.StringValue color = 3;
   */
  color?: string;
};

/**
 * Describes the message github.issues.v1.BoardBucketValue.
 * Use `create(BoardBucketValueSchema)` to create a new message.
 */
export const BoardBucketValueSchema: GenMessage<BoardBucketValue> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_update, 3);

/**
 * @generated from message github.issues.v1.BoardFieldResult
 */
export type BoardFieldResult = Message<"github.issues.v1.BoardFieldResult"> & {
  /**
   * @generated from field: string field = 1;
   */
  field: string;

  /**
   * The value now held. Unset when the write cleared the field.
   *
   * @generated from field: github.issues.v1.BoardBucketValue value = 2;
   */
  value?: BoardBucketValue;

  /**
   * Every bucket this field now puts the item in. A list from the first release because
   * launch fields genuinely return several, and the browser never learns which kind it is
   * looking at.
   *
   * @generated from field: repeated string keys = 3;
   */
  keys: string[];

  /**
   * What this write actually did, which differs from `keys` whenever the item already held
   * the target value. Undo and count settlement both read this and neither can
   * reconstruct it from `keys`.
   *
   * @generated from field: repeated string added = 4;
   */
  added: string[];

  /**
   * @generated from field: repeated string removed = 5;
   */
  removed: string[];

  /**
   * Whether `from` matched what was stored. Advisory, never a refusal.
   *
   * @generated from field: bool source_matched = 6;
   */
  sourceMatched: boolean;
};

/**
 * Describes the message github.issues.v1.BoardFieldResult.
 * Use `create(BoardFieldResultSchema)` to create a new message.
 */
export const BoardFieldResultSchema: GenMessage<BoardFieldResult> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_update, 4);

/**
 * @generated from message github.issues.v1.BoardCell
 */
export type BoardCell = Message<"github.issues.v1.BoardCell"> & {
  /**
   * @generated from field: string column_key = 1;
   */
  columnKey: string;

  /**
   * @generated from field: string row_key = 2;
   */
  rowKey: string;
};

/**
 * Describes the message github.issues.v1.BoardCell.
 * Use `create(BoardCellSchema)` to create a new message.
 */
export const BoardCellSchema: GenMessage<BoardCell> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_update, 5);

/**
 * @generated from message github.issues.v1.BoardUpdateResponse
 */
export type BoardUpdateResponse = Message<"github.issues.v1.BoardUpdateResponse"> & {
  /**
   * Echoed from the request, byte for byte.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * One entry per requested change, in request order.
   *
   * @generated from field: repeated github.issues.v1.BoardFieldResult results = 2;
   */
  results: BoardFieldResult[];

  /**
   * Where the card now sits, computed on the server from the written record rather than
   * from the index. A list because a multi-valued field puts the item in several buckets
   * on an axis and the cells are the product. An unswimlaned board's `row_key` is the
   * single row.
   *
   * @generated from field: repeated github.issues.v1.BoardCell cells = 3;
   */
  cells: BoardCell[];

  /**
   * False when the view's search constrains a field that just changed and the new value
   * contradicts that constraint. One flag over the whole write, because the board's
   * question is whether the card may stay, not which half of the move was objectionable.
   *
   * It does not answer whether the item still matches the whole view. That needs the
   * index, and index staleness is the problem this design absorbs. So it can be true while
   * some other qualifier has stopped holding.
   *
   * @generated from field: bool changed_field_matches_view = 4;
   */
  changedFieldMatchesView: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message github.issues.v1.BoardUpdateResponse.
 * Use `create(BoardUpdateResponseSchema)` to create a new message.
 */
export const BoardUpdateResponseSchema: GenMessage<BoardUpdateResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_update, 6);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(BoardFieldChangeSchema, "98462dd4d6ce")
registerSchemaHash(BoardArrangementSchema, "b60f16d15b3e")
registerSchemaHash(BoardUpdateRequestSchema, "b407acc0990a")
registerSchemaHash(BoardBucketValueSchema, "171ceab28562")
registerSchemaHash(BoardFieldResultSchema, "afbb25f647fe")
registerSchemaHash(BoardCellSchema, "612ea1a186d8")
registerSchemaHash(BoardUpdateResponseSchema, "3f755ab39ad5")
